function getAd() {
  // ✅ 1. localStorage（主来源）
  try {
    const raw = localStorage.getItem("ad");

    if (raw) {
      const parsed = JSON.parse(raw);

      if (isValidAd(parsed)) {
        return parsed;
      }
    }
  } catch (e) {
    // 忽略解析错误
  }

  // ✅ 2. cookie（兜底）
  const match = document.cookie.match(/(?:^|;\s*)ad=([^;]+)/);

  if (match) {
    const cookieAd = decodeURIComponent(match[1]);

    if (isValidAd(cookieAd)) {
      return cookieAd;
    }
  }

  // ✅ 3. 默认
  return "direct";
}

/**
 * ✅ 判断是否有效来源
 */
function isValidAd(val) {
  if (!val) return false;

  const invalid = ["unknown", "null", "undefined", ""];

  return !invalid.includes(String(val).toLowerCase());
}

export default getAd;